import { cva } from "class-variance-authority";

export { default as Assignees } from "./Assignees.vue";

export const sizes = ["sm", "md"];
export const avatarSizes = {
    sm: "xs",
    md: "sm",
};

export const assigneesWrapperVariants = cva(["font-medium"], {
    variants: {
        size: {
            sm: ["text-style-xs"],
            md: ["text-style-sm"],
        },
    },
});
